import React from "react";
import "../style.css";

/** Returns a div surrounded by dots */
export function DashedPanel({ children }: { children: React.ReactNode }) {
  return <div className="panel dashed-rectangle">{children}</div>;
}
